// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"0c39c52e","305":"f0624dcd"}[chunkId] + ".chunk.js";
};